/* eslint-disable prisma-rule/headings */

import type { FC, HTMLAttributes } from 'react';
import { cn } from 'src/utils/cn';

export type Mode = 'title' | 'section' | 'card' | 'sub-section' | 'footer'; // "footer" can be deleted after the rollout of the new design

export type HeadingProps = {
  /**
   * Changes the look of your heading.
   */
  mode: Mode;
};

const legacyBaseStyles = cn(`
  legacy:font-legacy-heading legacy:font-[900] legacy:text-legacy-brand
`);

const baseHeadlineStyles = cn(`
  not-legacy:font-family-headline not-legacy:font-headline
  not-legacy:text-foreground-default
`);

const baseTitleStyles = cn(`
  not-legacy:font-family-title not-legacy:font-title
  not-legacy:text-foreground-default
`);

export const Heading: FC<HeadingProps & HTMLAttributes<HTMLHeadingElement>> = ({
  mode,
  ...props
}) => {
  switch (mode) {
    case 'title':
      return (
        <h1
          {...props}
          className={cn(
            legacyBaseStyles,
            `
              legacy:text-[4.5rem] legacy:leading-[6.75rem]
              legacy:tracking-[-0.1rem]
            `,
            baseHeadlineStyles,
            `not-legacy:text-headline-l`,
            props.className
          )}
        />
      );
    case 'section':
      return (
        <h2
          {...props}
          className={cn(
            legacyBaseStyles,
            `
              legacy:text-[3rem] legacy:leading-[4.5rem]
              legacy:tracking-[-0.06rem]
            `,
            baseHeadlineStyles,
            `not-legacy:text-headline-m`,
            props.className
          )}
        />
      );
    case 'card':
      return (
        <h3
          {...props}
          className={cn(
            legacyBaseStyles,
            `
              legacy:text-[2rem] legacy:leading-[3.2rem]
              legacy:tracking-[-0.04rem]
            `,
            baseTitleStyles,
            `not-legacy:text-title-m`,
            props.className
          )}
        />
      );
    case 'sub-section':
      return (
        <h4
          {...props}
          className={cn(
            legacyBaseStyles,
            `legacy:font-base legacy:text-[1.8rem] legacy:leading-[3.2rem]`,
            baseTitleStyles,
            `not-legacy:text-title-s`,
            props.className
          )}
        />
      );
    case 'footer':
      return (
        <h4
          {...props}
          className={cn(
            legacyBaseStyles,
            `
              legacy:my-[1.05rem] legacy:font-base legacy:text-[1.8rem]
              legacy:leading-[3.2rem] legacy:text-white
            `,
            props.className
          )}
        />
      );
  }
};
